import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { DollarSign } from 'lucide-react';

const PaymentModal = ({
  selectedJob, paymentAmount, paymentNote, paymentMethod, paymentType,
  setPaymentAmount, setPaymentNote, setPaymentMethod, setPaymentType,
  onClose, onSubmit
}) => {
  return (
    <Dialog open={!!selectedJob} onOpenChange={onClose}>
      <DialogContent className="bg-gray-900 border-gray-700">
        <DialogHeader>
          <DialogTitle className="text-white">Ödeme Al - {selectedJob?.customerName}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="bg-gray-800 rounded-lg p-3 grid grid-cols-3 gap-2 text-center text-sm">
            <div><p className="text-gray-400 text-xs">Fiyat</p><p className="text-white font-bold">{(selectedJob?.currentPrice ?? selectedJob?.totalPrice)?.toLocaleString()} TL</p></div>
            <div><p className="text-gray-400 text-xs">Ödenen</p><p className="text-green-400 font-bold">{selectedJob?.paidAmount?.toLocaleString()} TL</p></div>
            <div><p className="text-gray-400 text-xs">Kalan</p><p className="text-red-400 font-bold">{selectedJob?.remainingBalance?.toLocaleString()} TL</p></div>
          </div>
          <Input type="number" placeholder="Tutar (TL)" value={paymentAmount} onChange={e => setPaymentAmount(e.target.value)}
            className="bg-gray-800 border-gray-700 text-white" data-testid="payment-amount-input" />
          <Select value={paymentMethod} onValueChange={setPaymentMethod}>
            <SelectTrigger className="bg-gray-800 border-gray-700 text-white" data-testid="payment-method-select">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-gray-900 border-gray-700">
              <SelectItem value="nakit" className="text-white hover:bg-gray-800">Nakit</SelectItem>
              <SelectItem value="havale_eft" className="text-white hover:bg-gray-800">Banka Havale / EFT</SelectItem>
              <SelectItem value="kredi_karti" className="text-white hover:bg-gray-800">Kredi Kartı</SelectItem>
              <SelectItem value="toptancidan" className="text-white hover:bg-gray-800">Toptancıdan Tahsilat</SelectItem>
            </SelectContent>
          </Select>
          <Select value={paymentType} onValueChange={setPaymentType}>
            <SelectTrigger className="bg-gray-800 border-gray-700 text-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-gray-900 border-gray-700">
              <SelectItem value="normal" className="text-white hover:bg-gray-800">Normal Ödeme</SelectItem>
              <SelectItem value="taksit" className="text-white hover:bg-gray-800">Taksit</SelectItem>
              <SelectItem value="soz" className="text-white hover:bg-gray-800">Söz / İleri Tarih</SelectItem>
            </SelectContent>
          </Select>
          <Input placeholder="Not (opsiyonel)" value={paymentNote} onChange={e => setPaymentNote(e.target.value)}
            className="bg-gray-800 border-gray-700 text-white" data-testid="payment-note-input" />
          {selectedJob?.payments?.length > 0 && (
            <div className="bg-gray-800 rounded-lg p-2">
              <p className="text-gray-400 text-xs mb-1">Ödeme Geçmişi</p>
              {selectedJob.payments.map((p, i) => (
                <div key={`pay-${p.date}-${i}`} className="flex justify-between text-xs py-0.5 border-b border-gray-700/30 last:border-0">
                  <span className="text-gray-300">{new Date(p.date).toLocaleDateString('tr-TR')} - {p.method === 'nakit' ? 'Nakit' : p.method === 'havale_eft' ? 'Havale' : p.method === 'kredi_karti' ? 'Kart' : p.method}</span>
                  <span className="text-green-400">{p.amount?.toLocaleString()} TL</span>
                </div>
              ))}
            </div>
          )}
          <Button onClick={onSubmit} className="w-full bg-green-600 hover:bg-green-700" data-testid="confirm-payment-btn">
            <DollarSign className="h-4 w-4 mr-1" />Ödemeyi Kaydet
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentModal;
